export default __webpack_public_path__ + "static/media/2930 cutlery side.f8e69773.png";